// Button state machine for the onboarding "Enable Theme Helper" step (Figma 44713-604708):
// idle → loading (spinner) → success (checkmark) → delay → dashboard.
export const ENABLE_THEME_HELPER_STATUS = {
  Idle: 'idle',
  Loading: 'loading',
  Success: 'success',
} as const;

export type IEnableThemeHelperStatus =
  (typeof ENABLE_THEME_HELPER_STATUS)[keyof typeof ENABLE_THEME_HELPER_STATUS];

// Delay between the success checkmark and landing on the dashboard.
export const ONBOARDING_SUCCESS_DELAY_MS = 2000;
